/** Jour calendaire Europe/Paris — planning opérationnel RDV. */

import { APP_TIMEZONE } from './equipeWeekParis';

export function parisYmd(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: APP_TIMEZONE }).format(date);
}

export function addDaysYmd(ymd, days) {
  const [y, m, d] = ymd.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + days, 12, 0, 0));
  return dt.toISOString().slice(0, 10);
}

/** Bornes locales Paris pour query dateMin / dateMax. */
export function getParisDayApiRange(ymd) {
  return {
    dateMin: `${ymd}T00:00:00`,
    dateMax: `${ymd}T23:59:59`,
    ymd,
  };
}

export function formatParisDayTitle(ymd) {
  const date = new Date(`${ymd}T12:00:00`);
  const label = new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: APP_TIMEZONE,
  }).format(date);
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function formatParisClock(iso) {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: APP_TIMEZONE,
  })
    .format(new Date(iso))
    .replace(':', 'h');
}

/** Heure 09:00 — libellé planning (maquette). */
export function formatParisClockColon(iso) {
  return formatParisClock(iso).replace('h', ':');
}

/** Minutes depuis minuit (Europe/Paris). */
export function parisMinutesFromMidnight(iso) {
  if (!iso) return 0;
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: APP_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(new Date(iso));
  const hour = Number(parts.find((p) => p.type === 'hour')?.value || 0);
  const minute = Number(parts.find((p) => p.type === 'minute')?.value || 0);
  return hour * 60 + minute;
}

export function rdvDurationMinutes(rdv) {
  if (rdv?.dateDebut && rdv?.dateFin) {
    const ms = new Date(rdv.dateFin) - new Date(rdv.dateDebut);
    if (Number.isFinite(ms) && ms > 0) return Math.max(15, Math.round(ms / 60000));
  }
  const reserved = Number(rdv?.dureeMinutesReservee);
  if (Number.isFinite(reserved) && reserved > 0) return reserved;
  const presta = Number(rdv?.prestation?.dureeMinutes);
  if (Number.isFinite(presta) && presta > 0) return presta;
  return 60;
}

export function clientDisplayName(user) {
  if (!user) return 'Client';
  const name = [user.prenom, user.nom].filter(Boolean).join(' ').trim();
  if (name) return name;
  if (user.email) return user.email;
  if (user.telephone) return user.telephone;
  return 'Client';
}

export function intervenantDisplayName(memberOrInstructeur) {
  if (!memberOrInstructeur) return 'Intervenant';
  const name = [memberOrInstructeur.prenom, memberOrInstructeur.nom]
    .filter(Boolean)
    .join(' ')
    .trim();
  return name || 'Intervenant';
}
